module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-man-50@2x_8350913319d5730d6189ff5d9cfdba95.jpg";